import { render, staticRenderFns } from "./SetClipartMeasurement.vue?vue&type=template&id=4ea09abd&scoped=true"
import script from "./SetClipartMeasurement.vue?vue&type=script&lang=js"
export * from "./SetClipartMeasurement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea09abd",
  null
  
)

export default component.exports